import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import PayrollManagement from '../components/PayrollManagement';

const AdminSalaryStructuresPage = ({ dashboardHomePath = '/admin', scope = 'tenant' }) => {
  const isGlobalScope = scope === 'global';
  const navigate = useNavigate();
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-foreground">{isGlobalScope ? 'Global Salary Structures' : 'Salary Structures'}</h2>
          <p className="text-sm text-muted-foreground">
            {isGlobalScope ? 'Manage platform-wide salary structure defaults.' : 'Dedicated page for salary structure master data.'}
          </p>
        </div>
        <Button variant="outline" onClick={() => navigate(dashboardHomePath)}>
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>
      </div>
      <PayrollManagement
        currentTab="salary-structures"
        hiddenTabs={['overview', 'my-salary', 'tax-slabs', 'reimbursements', 'employee-salaries', 'payroll-process', 'payslips']}
        scope={scope}
      />
    </div>
  );
};

export default AdminSalaryStructuresPage;
